import React from 'react'
import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Tooltip, Checkbox, InputAdornment } from '@material-ui/core'

export default function ExcessAmountModal({data, onProceed, params, onClose}) {
    let status = data?.previous_invoice?.status
    let invUrl = `/${params?.type}/${params?.aircraft_slug}/contract/${params?.contract_slug}/invoice/view/${data?.previous_invoice?.id}` 

    
    return (
        <div>
            <Dialog style={{ zIndex: "2300" }} open='true' maxWidth={'sm'} className='mou-dialog'>
                <DialogContent dividers >
                Dear User,<br/> Please note that the previous invoice <span style={{color:'#6790be', textDecoration:'underline', cursor:"pointer"}} onClick={()=>window.open(invUrl,'_blank')}>{data?.previous_invoice?.name} </span> is {status =='1' ? 'Sent (not paid)' :status =='2' ? 'Partially paid' : 'Paid in excess'}.
                Please click on Proceed to continue generating the invoice and follow up with the lessee if required.  
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginLeft: "15px" }} color="primary" size='small' variant='outlined' onClick={onClose}>Close</Button>
                    <Button style={{ marginLeft: "15px" }} color="primary" size='small' variant='contained' onClick={onProceed}>Proceed</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
